export default "__VITE_PUBLIC_ASSET__4139d91c__"